import { inject, Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Environment, environmentToken } from '@environment';
import { Observable } from 'rxjs';
import { NetworkMigrationWorkflow, NetworkMigrationWorkflows, } from '@app/shared/models/network-migration.model';
import { BleKeyDeliveryNodeState, BLEKeyDeliveryProgressApiResponse, BLEKeyDeliveryRetryApiResponse } from '@app/shared/models/nms.models';

@Injectable({ providedIn: 'root' })
export class NetworkMigrationResource {
  private readonly baseUrl: string;
  private readonly httpClient = inject(HttpClient);
  constructor(@Inject(environmentToken) private readonly environment: Environment) {
    this.baseUrl = `${this.environment.apiUrl}${this.environment.apiPath}`;
  }

  getManagingCompanies(): Observable<{ id: number; companyName: string }[]> {
    return this.httpClient.get<{ id: number; companyName: string }[]>(`${this.baseUrl}/managing-company`);
  }

  loadBLEKeyDelivery(buildingId: number): Observable<BLEKeyDeliveryProgressApiResponse> {
    return this.httpClient.get<BLEKeyDeliveryProgressApiResponse>(
      `${this.baseUrl}/ble-key-delivery/building/${buildingId}/sessions/latest/progress`);
  }

  retryBLEKeyDelivery(buildingId: number, workflowId: number): Observable<BLEKeyDeliveryRetryApiResponse> {
    return this.httpClient.post<BLEKeyDeliveryRetryApiResponse>(
      `${this.baseUrl}/ble-key-delivery/building/${buildingId}/workflows/${workflowId}/retry`, {});
  }

  getAllMigrationTransfer(): Observable<NetworkMigrationWorkflows> {
    return this.httpClient.get<NetworkMigrationWorkflows>(`${this.baseUrl}/ble-key-delivery/post-otap-workflows`);
  }

  startNewTransfer(buildingId: number): Observable<NetworkMigrationWorkflow> {
    return this.httpClient.post<NetworkMigrationWorkflow>(
      `${this.baseUrl}/ble-key-delivery/building/${buildingId}/start-post-otap-workflow`, {});
  }

  getBuildingPostTransferNodes(buildingId: number, workflowId: number): Observable<BleKeyDeliveryNodeState[]> {
    return this.httpClient.get<BleKeyDeliveryNodeState[]>(
      `${this.baseUrl}/ble-key-delivery/building/${buildingId}/post-otap-workflows/${workflowId}/nodes`);
  }

  getBuildingMigrationTransferProgress(
    buildingId: number,
    workflowId: number
  ): Observable<BLEKeyDeliveryProgressApiResponse> {
    return this.httpClient.get<BLEKeyDeliveryProgressApiResponse>(
      `${this.baseUrl}/ble-key-delivery/building/${buildingId}/post-otap-workflows/${workflowId}/progress`);
  }
}
